<template>

    <div class="profile-dashboard__pets-list">

        <div class="profile-dashboard__pets-add">

            <a href="/publication/pet" class="btn btn--primary d-flex">
                {{$store.getters.t('user_dashboard_add_my_ward')}} <span>&plus;</span>
            </a>

        </div>

        <template v-if="pets.length && loaded">
            <div class="profile-dashboard__pets-slider" v-if="pets.length > 1">
                <swiper ref="swiper" class="swiper" :options="swiperOptionsAnimal">

                    <swiper-slide v-for="(pet, idx) in pets" :key="idx">
                        <div class="profile-pet">
                            <div class="profile-pet__inner d-flex">
                                <div class="profile-pet__header">

                                    <span class="profile-pet__label" :class="`profile-pet__label--${pet.isModerated}`" v-if="pet.isModerated">
                                        {{isModerateDictionary[pet.isModerated]}}
                                    </span>

                                    <div class="profile-pet__header-image"
                                         :class="{'grayscale': pet.archive_reason === 'died'}"
                                         :style="'background-image: url(/storage'+ pet.avatar.path.replace('original', 'preview_l') +')'"
                                         v-if="pet.avatar"></div>
                                    <a :href="`/publication/pet/${pet.id}`" class="profile-pet__header-link">{{$store.getters.t('common_edit')}}</a>

                                    <div class="archive-reason d-flex"
                                         v-if="pet.archive_reason === 'home_found' || pet.archive_reason === 'adopted_by_volunteer'">
                                        <img src="/assets/images/icons/home.svg" alt="">
                                    </div>

                                </div>

                                <div class="profile-pet__body">
                                    <div class="profile-pet__title d-flex">
                                        <a :href="'/pets/' + pet.id" class="profile-pet__name" v-text="pet.name"></a>
                                        <div class="profile-pet__location" v-if="pet.city">
                                            {{ pet.city.name }}
                                        </div>
                                    </div>
                                    <div class="profile-pet__description" v-text="pet.ad_title"></div>
                                    <div class="rating">
                                        <p>{{ (+pet.donationsProgress).toFixed() }} %</p>
                                        <div class="rating-block progress">
                                            <div class="filled" v-if="(+pet.donationsProgress).toFixed() < 100"
                                                 :style="{width: (+pet.donationsProgress).toFixed() < 100 ? (+pet.donationsProgress).toFixed() + '%' : '',
                                                              background:  '#EE7372'}"></div>
                                            <div class="filled" v-if="(+pet.donationsProgress).toFixed() >= 100"
                                                 :style="{width: '100%', background: '#91DA66'}"></div>
                                        </div>
                                    </div>

                                    <ul class="d-flex stats" v-if="(+pet.donationsProgress).toFixed() < 100">
                                        <li>
                                            <p>{{ pet.donationsTotal }} USD</p>
                                            <span>{{$store.getters.t('catalog_pet_collected')}}</span>
                                        </li>
                                        <li class="line">
                                            <p>{{ pet.need_sum }} USD</p>
                                            <span>{{$store.getters.t('catalog_pet_goal')}}</span>
                                        </li>
                                    </ul>

                                    <ul class="d-flex stats stats--done" v-else>
                                        <li>
                                            <p>
                                                {{ pet.need_sum }} USD
                                            </p>
                                            <span>
                                                    {{$store.getters.t('tab_pet_goal_reached')}}
                                                <img src="/assets/images/icons/done.svg" alt="">
                                            </span>
                                        </li>
                                    </ul>

                                    <div class="info" v-if="loyalty && pet.is_moderated !== 2 && pet.is_moderated !== 3 && !pet.up_allowed">
                                        {{$store.getters.t('tab_pet_auto_up_pet')}}
                                    </div>
                                    <div class="info" v-else-if="!loyalty && pet.until_up_allowed">
                                        {{$store.getters.t('tab_pet_can_raise_until')}} {{pet.until_up_allowed}}
                                    </div>

                                    <div class="actions d-flex" >

                                        <a v-if="((pet.up_allowed) && (pet.user_id === user.id) && (pet.is_moderated !== 2 && pet.is_moderated !== 3) && !loyalty )"
                                           href="#" @click.prevent="actualizePet(pet.id)" class="btn">{{$store.getters.t('tab_pet_raise_button')}}</a>
                                        <a :href="'/publication/pet/' + pet.id" class="btn btn-light">{{$store.getters.t('common_edit')}}</a>

                                    </div>

                                </div>
                            </div>

                        </div>

                    </swiper-slide>


                </swiper>

                <div class="slider-navigations">
                    <div id="animals-list-prev" class="swiper-button-prev" slot="button-prev"></div>
                    <div id="animals-list-next" class="swiper-button-next" slot="button-next"></div>
                </div>
            </div>
            <div class="d-flex" v-else>

                <div class="profile-pet" v-for="(pet, idx) in pets" :key="idx">
                    <div class="profile-pet__inner d-flex">
                        <div class="profile-pet__header">

                            <span class="profile-pet__label" :class="`profile-pet__label--${pet.isModerated}`" v-if="pet.isModerated">
                                {{isModerateDictionary[pet.isModerated]}}
                            </span>

                            <div class="profile-pet__header-image" :class="{'grayscale': pet.archive_reason === 'died'}"
                                 :style="'background-image: url(/storage'+ pet.avatar.path.replace('original', 'preview_l') +')'"
                                 v-if="pet.avatar"></div>
                            <a :href="`/publication/pet/${pet.id}`" class="profile-pet__header-link">{{$store.getters.t('common_edit')}}</a>

                            <div class="archive-reason d-flex"
                                 v-if="pet.archive_reason === 'home_found' || pet.archive_reason === 'adopted_by_volunteer'">
                                <img src="/assets/images/icons/home.svg" alt="">
                            </div>

                        </div>

                        <div class="profile-pet__body">
                            <div class="profile-pet__title d-flex">
                                <a :href="'/pets/' + pet.id" class="profile-pet__name" v-text="pet.name"></a>
                                <div class="profile-pet__location" v-if="pet.city">
                                    {{ pet.city.name }}
                                </div>
                            </div>
                            <div class="profile-pet__description" v-text="pet.ad_title"></div>
                            <div class="rating">
                                <p>{{ (+pet.donationsProgress).toFixed() }} %</p>
                                <div class="rating-block progress">
                                    <div class="filled" v-if="(+pet.donationsProgress).toFixed() < 100"
                                         :style="{width: (+pet.donationsProgress).toFixed() < 100 ? (+pet.donationsProgress).toFixed() + '%' : '',
                                                              background:  '#EE7372'}"></div>
                                    <div class="filled" v-if="(+pet.donationsProgress).toFixed() >= 100"
                                         :style="{width: '100%', background: '#91DA66'}"></div>
                                </div>
                            </div>

                            <ul class="d-flex stats" v-if="(+pet.donationsProgress).toFixed() < 100">
                                <li>
                                    <p>{{ pet.donationsTotal }} USD</p>
                                    <span>{{$store.getters.t('catalog_pet_collected')}}</span>
                                </li>
                                <li class="line">
                                    <p>{{ pet.need_sum }} USD</p>
                                    <span>{{$store.getters.t('catalog_pet_goal')}}</span>
                                </li>
                            </ul>

                            <ul class="d-flex stats stats--done" v-else>
                                <li>
                                    <p>
                                        {{ pet.need_sum }} USD
                                    </p>
                                    <span>
                                                    Цель достигнута
                                                <img src="/assets/images/icons/done.svg" alt="">
                                            </span>
                                </li>
                            </ul>

                            <div class="info" v-if="loyalty && pet.is_moderated !== 2 && pet.is_moderated !== 3 && !pet.up_allowed">
                                {{$store.getters.t('tab_pet_auto_up_pet')}}
                            </div>
                            <div class="info" v-else-if="!loyalty && pet.until_up_allowed">
                                {{$store.getters.t('tab_pet_can_raise_until')}} {{pet.until_up_allowed}}
                            </div>

                            <div class="actions d-flex" >

                                <a v-if="((pet.up_allowed) && (pet.user_id === user.id) && (pet.is_moderated !== 2 && pet.is_moderated !== 3) && !loyalty )"
                                   href="#" @click.prevent="actualizePet(pet.id)" class="btn">{{$store.getters.t('tab_pet_raise_button')}}</a>
                                <a :href="'/publication/pet/' + pet.id" class="btn btn-light">{{$store.getters.t('common_edit')}}</a>

                            </div>
                        </div>
                    </div>

                </div>

            </div>
        </template>
        <template v-else-if="!loaded">
            <div class="profile-dashboard__pets-slider profile-dashboard__pets-slider--empty d-flex">
                <div class="LoaderBalls">
                    <div class="LoaderBalls__item"></div>
                    <div class="LoaderBalls__item"></div>
                    <div class="LoaderBalls__item"></div>
                </div>
            </div>
        </template>
        <template v-else>
            <div class="profile-dashboard__pets-slider profile-dashboard__pets-slider--empty d-flex">
                {{$store.getters.t('tab_pet_empty_list')}}
            </div>
        </template>


    </div>


</template>

<script>

import { mapGetters } from 'vuex';

import {Swiper, SwiperSlide} from 'vue-awesome-swiper';

export default {
    name: "UserDashboardPets",
    components: {Swiper, SwiperSlide},
    props: ['user'],
    data() {
        return {
            pets: [],
            loaded: false,
            swiperOptionsAnimal: {
                slidesPerView: 2,
                spaceBetween: 24,
                loop: true,
                navigation: {
                    nextEl: '#animals-list-next',
                    prevEl: '#animals-list-prev',
                },
                breakpoints: {
                    320: {
                        slidesPerView: 1, // or 'auto'
                        spaceBetween: 10,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 24,
                    },
                },
            },

            isModerateDictionary: {
                registered: this.$store.getters.t('tab_pet_status_created'),
                approved:   this.$store.getters.t('tab_pet_status_approved'),
                pending:    this.$store.getters.t('tab_pet_status_moderation'),
                rejected:   this.$store.getters.t('tab_pet_status_rejected'),
            }

        }
    },


    mounted() {
        this.getPersonalPets()
    },

    watch: {
        pets() {
            setTimeout(() => {
                this.loaded = true
            }, 1000)
        }
    },

    computed: {

        ...mapGetters({
            loyalty: 'getUserLoyalty'
        })

    },

    methods: {

        actualizePet(id) {
            axios.post('/pets/actualize', {'pet_id':id})
                .then(response => {
                    response = response.data;
                })
                .then(response => {
                    this.getPersonalPets();
                })
                .catch()
        },

        getPersonalPets() {

            let params = {
                type: 'PET_TYPE_VOLUNTEER',
                status: 1,
                up_allowed: null,
                is_moderated: 'any',
                per_page: 10,
                page: 1
            };

            axios.get(`/user/${this.user.id}/pets`, {params: params})
                .then(response => {
                    response = response.data

                    if (response.success) {
                        this.pets = response.data.map( _item => {

                            _item.isModerated = null;

                            switch ( _item.is_moderated ) {

                                case 0:
                                    _item.isModerated = `registered`;
                                    break;

                                case 1:
                                    _item.isModerated = `approved`;
                                    break;

                                case 2:
                                    _item.isModerated = `pending`;
                                    break;

                                case 3:
                                    _item.isModerated = `rejected`
                                    break;

                                default:
                                    break;

                            }

                            return _item;

                        } );
                    }

                })
                .catch(error => {
                    error = error.response.data

                    if (!error.success) console.log(error)

                })
        }

    }

}
</script>

<style lang="scss" scoped>
.LoaderBalls {
    margin: 0 auto;
    width: 90px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    &__item {
        $anim-drt: 0.3s;
        $anim-ease: cubic-bezier(.6, .05, .15, .95);
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #2E76E4;

        &:nth-child(1) {
            animation: bouncing $anim-drt alternate infinite $anim-ease;
        }

        &:nth-child(2) {
            animation: bouncing $anim-drt $anim-drt/4 alternate infinite $anim-ease backwards;
        }

        &:nth-child(3) {
            animation: bouncing $anim-drt $anim-drt/2 alternate infinite $anim-ease backwards;
        }
    }
}


@keyframes bouncing {

    0% {
        transform: translate3d(0, 10px, 0) scale(1.2, 0.85);
    }

    100% {
        transform: translate3d(0, -20px, 0) scale(0.9, 1.1);
    }
}

</style>
